export default {
  "rules.createRule": "ルールを作成する",
  "rules.createPriceRuleTemplate": "ルールを作成する",
  "rules.generalPricing": "一般価格設定",
  "rules.otherTicketTypeSettings": "その他券種設定",
  "rules.versionSurcharge": "パージョン追加料金",
  "rules.seatPricingRules": "座席料金規則",
  "rules.nationwideTicketSetting": "全国共通券設定",
  "rules.plsSelectTicketCategory": "券種カテゴリ選択してください",
  "rules.plsEnterAdditionalCharge": "追加料金を入力してください",
  "rules.formDispClassificationSetting": "帳票表示区分設定",
  "rules.formDispClassification_entertainment": "帳票表示区分（興行）",
  "rules.availabilityMovieTickets": "ムビチケ（システム連携専用）利用可否",
  "rules.available": "利用可能",
  "rules.unusable": "利用不可",
  "rules.availabilityOtherNationalTickets": "その他全国共通券利用可否",
  "rules.theaterAdvTicketInvitationTicket": "劇場前売券/招待券設定",
  "rules.notAvailableTicketInvitationTicket_multi": "利用不可劇場前売券/招待券（複数選択可）",
  "rules.additionalFee": "追加料金",
  "rules.reflectionInBoxOffice": "興行収入への反映",
  "rules.useOfNationalTickets": "全国共通券利用",
  "rules.useTheaterAdvTickets": "劇場前売券利用",
  "rules.useInvitationTicket": "招待券利用",
  "rules.notAvailableCoupons_multi": "利用不可劇場優待券（クーポン・引換券）（複数選択可）",
  "rules.notAvailableMovieCoupons_multi": "利用不可劇場優待券 / 引換券（複数選択可）",
  "rules.POSDisplayGroup": "POS表示グループ",
  "rules.ticketCategory": "券種カテゴリ",
  "rules.availableTarget_multi": "利用可能対象者（複数選択可）",
  "rules.purchaseUnit_sheets": "購入単位（枚）",
  "rules.tempHoldType": "仮押さえタイプ",
  "rules.displayDate_multi": "表示日（複数選択）",
  "rules.unspecified": "指定なし",
  "rules.undisplayDate_multi": "日付の非表示（複数選択）",
  "rules.deviceUndisplay_multi": "デバイスの非表示（複数選択）",
  "rules.notAvailableSpecialSeats_multi": "利用不可特別席（複数選択可）",
  "rules.alertMessage": "アラートメッセージ",
  "rules.generalSeat": "一般席",
  "rules.wheelchair": "車椅子席",
  "rules.VIPSeat": "VIP席",
  "rules.specialSeat": "特別席",
  "rules.closeSeat": "座席を閉じる",
  "rules.onlineCloseSeat": "オンラインクローズシート",
  "rules.POSCloseSeat": "POS 座席を閉じる",
  "rules.accidentCloseSeat": "アクシデントクローズシート",
  "rules.soldSeat": "売り切れシート",
  "rules.loversSeat": "ペアシート",
  "rules.salesSettings": "販売設定",
  "rules.salesStartTime": "販売開始時間",
  "rules.salesEndTime": "販売終了時間",
  "rules.maxNumOfPurchases": "最大購入枚数",
  "rules.preSaleRank": "先行販売会員ランク",
  "rules.preSaleTime": "先行販売時間",
  "rules.screeningDate_fromDay": "上映日の○日前○時から",
  "rules.screeningDate_fromMinute": "上映開始時間の○時間前から",
  "rules.screeningDate_fromHour": "指定した日時から",
  "rules.screeningDate_specialTime": "◯曜日◯時◯分から◯日分のスケジュールを公開する",
  "rules.screeningDate_untilDay": "上映日の○日前○時まで",
  "rules.screeningDate_untilMinute": "上映開始時間の○分前まで",
  "rules.screeningDate_untilAfterMinute": "上映開始時間の○分後まで",
  "rules.screeningDate_untilHour": "指定した日時まで",
  "rules.mobolize": "調整動員",
  "rules.standingmax" : "立見席数量",
  "rules.standingmax.p": "立見席数量を入力してください",
  "rules.confirmtemplate": "表示設定",
  "rules.confirmoptions": "表示開始時間（オンライン）",
  "rules.confirm.option.1": "スケジュール作成したすぐ",
  "rules.confirm.option.2": "上映開始時間の○時間前から",
  "rules.confirm.option.3": "上映日の○日前○時から",
  "rules.revisedEdition": "前売券等転用不可バージョン（複数選択可）",
  "rules.allVersion": "すべてのバージョン",
  "rules.ticketID.forCurrentCinemaLoyalty": "クーポン・割引券ID（現行CINEMA LOYALTY用）",
  "rules.ticketID.forCurrentCinemaLoyalty.placeholder": "入力してください",
  "rules.addTicket": "券種追加",
  "rules.removeTicket": "券種削除",
  "rules.cl": "適用会員クーポン",
  "rules.sellTogether": "一緒に販売する売店アイテム",
  "rules.shopItemsAmount": "売店アイテム計上金額",
  "rules.ticketAmount": "チケット興行収入計上金額",
};